"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionCopy = /** @class */ (function (_super) {
    __extends(TableActionCopy, _super);
    function TableActionCopy(props) {
        return _super.call(this, props) || this;
    }
    TableActionCopy.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    TableActionCopy.prototype.getRenderObjectNoQuery = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: "copy", ghost: true, type: "primary", style: { marginLeft: "1px", marginRight: "1px" }, onClick: this.buttonClick.bind(this) })));
    };
    TableActionCopy.prototype.getRenderObjectWithQuery = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Popconfirm, { placement: "left", title: this.props.confirmText, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442", onConfirm: this.buttonClick.bind(this) },
                React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: "copy", ghost: true, type: "primary", style: { marginLeft: "1px", marginRight: "1px" } }))));
    };
    TableActionCopy.prototype.render = function () {
        if (this.props.confirmText) {
            return (this.getRenderObjectWithQuery());
        }
        else {
            return (this.getRenderObjectNoQuery());
        }
    };
    return TableActionCopy;
}(React.Component));
exports.default = TableActionCopy;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_actions/TableActionCopy.tsx
// module id = 101
// module chunks = 0